import _ from 'underscore';
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import Slider from 'components/sliders/BaseSlider';

import { EntitiesPropType, MixedEntitiesPropType } from 'propTypes/common';
import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

import styles from './styles.module.scss';

const CardBlock = memo(({ entities, Card, inverted }) => {
	const sliderParams = useMemo(
		() => ({
			slidesPerView: 'auto',
			grid: {
				rows: 1
			},
			spaceBetween: 8,
			slidesOffsetBefore: 8,
			slidesOffsetAfter: 8,
			breakpoints: {
				[SCREEN_BREAKPOINTS.mobileLarge]: {
					slidesPerView: 2,
					grid: {
						rows: 2
					},
					spaceBetween: 16,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0
				},
				[SCREEN_BREAKPOINTS.tabletLarge]: {
					slidesPerView: 2,
					grid: {
						rows: 2
					},
					spaceBetween: 24,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0
				}
			}
		}),
		[]
	);

	const content = useMemo(() => {
		let blocks = null;

		if (!_.isEmpty(entities) && entities.length >= 5) {
			blocks = [
				<div key="single" className={styles.CardBlock__Single}>
					<Card
						entityType={entities[0].entityType}
						entity={entities[0]}
						size="large"
						params={{ height: 532, width: 732 }}
					/>
				</div>,
				<Slider
					key="slider"
					className={styles.CardBlock__Slider}
					params={sliderParams}
					theme="multirow"
				>
					{entities.slice(1, 5).map((entity) => (
						<Card
							key={entity._id}
							className={styles.CardBlock__Card}
							entity={entity}
							entityType={entity.entityType}
							params={{ height: 315, width: 430 }}
						/>
					))}
				</Slider>
			];

			if (inverted) {
				blocks.reverse();
			}
		}

		return blocks;
	}, [inverted, entities, Card]);

	return content && <div className={styles.CardBlock}>{content}</div>;
});

CardBlock.propTypes = {
	entities: PropTypes.oneOfType([MixedEntitiesPropType, EntitiesPropType])
		.isRequired,
	Card: PropTypes.elementType.isRequired,
	inverted: PropTypes.bool
};

CardBlock.defaultProps = {
	inverted: false
};

export default CardBlock;
